var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"atom-title",class:( _obj = {}, _obj[_vm.size] = _vm.size, _obj.center = _vm.center, _obj.italic = _vm.italic, _obj )},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }